/**
 * @file 과업 요청서 상태·버전 표시 상수 — 라벨·색상의 단일 출처.
 * (백엔드 enum 과 키가 1:1 대응. 상태를 추가하면 여기와 WorkRequestStatus.java 를 함께 고친다)
 */

/** 상태별 표시 — 진행 순서대로. chip 배경/글자색은 designSystem 팔레트 톤에 맞춘 값. */
export const STATUS_META = {
    REQUESTED:        { label: "요청",     bg: "#eff6ff", fg: "#1e40af", border: "#bfdbfe" },
    ACCEPTED:         { label: "접수",     bg: "#f0f9ff", fg: "#0369a1", border: "#bae6fd" },
    IN_PROGRESS:      { label: "진행중",   bg: "#fefce8", fg: "#a16207", border: "#fde68a" },
    REVIEW_REQUEST:   { label: "검토요청", bg: "#f5f3ff", fg: "#6d28d9", border: "#ddd6fe" },
    REVISION_REQUEST: { label: "수정요청", bg: "#fef2f2", fg: "#b91c1c", border: "#fecaca" },
    COMPLETED:        { label: "완료",     bg: "#f0fdf4", fg: "#15803d", border: "#bbf7d0" },
};

/** 필터 드롭다운·범례에서 쓰는 표시 순서. */
export const STATUS_ORDER = [
    "REQUESTED", "ACCEPTED", "IN_PROGRESS", "REVIEW_REQUEST", "REVISION_REQUEST", "COMPLETED",
];

export const statusMeta = (status) =>
    STATUS_META[status] || { label: status || "-", bg: "#f1f5f9", fg: "#475569", border: "#e2e8f0" };

// 버전의 요청/응답 구분 색·라벨은 WorkRequestTimeline 의 SIDE_STYLE 이 단일 출처다
// (아이콘까지 함께 묶여 있어 거기 두는 편이 흩어지지 않는다).

/**
 * 내 역할·현재 상태로 가능한 상태 전이 버튼을 계산.
 *
 * <p><b>사람이 누르는 상태 버튼은 '완료' 하나뿐이다.</b> 접수·작업시작·다시진행 같은 중간 단계는
 * 없앴다 — 눌러야 넘어가는 단계는 실제로 아무도 안 눌러서 목록의 상태가 현실과 어긋나고,
 * 그러면 상태 자체를 아무도 안 믿게 된다. 나머지 전이는 파일을 올리는 행위로 자동 처리한다:
 * 담당자가 올리면 '검토요청', 요청자가 올리면 '수정요청'.
 *
 * <p>수정요청도 별도 버튼을 두지 않는다 — 요청자가 피드백·파일을 올리는 것이 곧 수정요청이다.
 *
 * <p>화면 편의일 뿐 권한의 근거가 아니다 — 서버가 같은 규칙을 다시 강제한다.
 *
 * @returns {Array<{status,label,variant,needsReason}>}
 */
export function availableActions({ status, isRequester }) {
    if (!isRequester) return [];               // 담당자는 파일만 올리면 된다
    if (status === "REVIEW_REQUEST") {
        return [{ status: "COMPLETED", label: "승인·완료", variant: "primary" }];
    }
    if (status === "COMPLETED") {
        return [{ status: "REVISION_REQUEST", label: "재오픈", variant: "secondary", needsReason: true }];
    }
    return [];
}

/** 지금 파일을 올릴 수 있는 상태인지 — 완료만 아니면 언제든 (백엔드 canSubmitDelivery 와 동일). */
export const canSubmitDelivery = (status) => status !== "COMPLETED";
